namespace $.$$ {

	export class $shm_tests_benchmarks extends $.$shm_tests_benchmarks {

		body_rows() {
			return this.Table().has_benchmarks()
				? [ this.Table() ]
				: [ this.Empty() ]
		}

	}

}
